'use client';

import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';

// Components
import { Header as HeaderBase } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ErrorContent } from '@/components/ErrorContent';

// Constants
import { IMAGES, ROUTES } from '@shared/constants';
import { IMAGES as IMAGE, CONTENT_MESSAGE, ERROR_MESSAGES } from '@/constants';
const Error = ({
  error,
  reset
}: {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}) => {
  useEffect(() => {
    captureException(error);
  }, [error]);
  const handleRefresh = () => {
    reset();
  };
  return <div className="flex flex-col h-screen" data-sentry-component="Error" data-sentry-source-file="error.tsx">
      {/* Header */}
      <HeaderBase logo={{
      src: {
        lightMode: IMAGES.LOGO_AGILITY
      },
      alt: 'Logo of the application',
      width: 102,
      height: 26
    }} className="bg-white mx-0 flex items-center justify-between h-header-sm" classCustom="mx-0 px-6 py-0 md:px-7.5" href={ROUTES.HOME} data-sentry-element="HeaderBase" data-sentry-source-file="error.tsx" />

      {/* Content */}
      <ErrorContent imageSrc={IMAGE.LOGO_ERROR} imageAlt="Logo error page" imageClass="w-logo-error-mobi h-logo-error-mobi md:w-logo-error md:h-logo-error -mt-6 md:-mt-12" buttonLabel="Try again" onClick={handleRefresh} title={ERROR_MESSAGES.PAGE_ERROR} subtitle={CONTENT_MESSAGE.PAGE_ERROR} className="pb-10 md:pb-16" data-sentry-element="ErrorContent" data-sentry-source-file="error.tsx" />

      {/* Footer */}
      <Footer data-sentry-element="Footer" data-sentry-source-file="error.tsx" />
    </div>;
};
export default Error;